import React from 'react';

export default function SkipLink(){
  const style: React.CSSProperties = {
    position:'absolute', left:8, top: -40, padding:'8px 12px',
    background:'#000', color:'#fff', borderRadius:6, zIndex:1000
  };
  const focusStyle: React.CSSProperties = { top:8 };
  // We apply :focus style via CSS in index.css; inline here as default
  return (
    <a href="#content" style={style} className="skip-link">
      Skip to main content
    </a>
  );
}